/* @flow */
import BaseRenderer from './index'

export default class HpubRenderer extends BaseRenderer {
}
